import React, { useState } from 'react';
import { Drawer, Button, Form, Input } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined, LockFilled } from '@ant-design/icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useStateValue } from '../../providers/StateProvider';
import { catchRequest } from '../../utils';

const ChangePassword = () => {
    const [{ token, id }, dispatch] = useStateValue();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ id, contrasenia: '', nuevacontra: '', nuevacontra2: '' });

    const handleChange = (e, type) => {
        setForm({ ...form, [type]: e.target.value });
    };

    const handleSubmit = () => {
        if (form.nuevacontra === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Contraseña vacia',
                text: 'Ingrese una contraseña nueva.',
            });
            return;
        }
        if (form.nuevacontra !== form.nuevacontra2) {
            Swal.fire({
                icon: 'warning',
                title: 'Contraseñas diferentes',
                text: 'No coinciden las contraseñas ingresadas, asegurate de escribirlas bien.',
            });
            return;
        }
        setLoading(true);
        axios({
            method: 'POST',
            url: '/general/general/updPassword',
            data: form,
            headers: { Authorization: token },
        }).then(({ data }) => {
            setLoading(false);
            // eslint-disable-next-line no-restricted-syntax
            'refreshToken' in data && dispatch({ type: 'ADD_TOKEN', item: { token: data.refreshToken } });
            if (data.ok) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Contraseña actualizada con éxito.',
                });
                setVisible(false);
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Algo ha salido mal...',
                    text: `${ data?.message ? data.message : 'Contacte al administrador.' }`,
                });
            }
        })
            .catch((e) => {
                setLoading(false);
                catchRequest(e, dispatch);
            });
    };

    return (
        <>
            <div className="d-flex flex-row">
                <LockFilled className="mr-3 align-self-center" />
                <Button type="link" className="mt-3" onClick={() => setVisible(true)}>Cambiar contraseña</Button>
            </div>
            <Drawer
                title="Actualizar contraseña"
                placement="right"
                closable={false}
                onClose={() => setVisible(false)}
                visible={visible}
                destroyOnClose
                footer={[
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={() => setVisible(false)} style={{ marginRight: 8 }} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button loading={loading} type="primary" form="myForm" key="submit" htmlType="submit">
                            Actualizar
                        </Button>
                    </div>,
                ]}

            >
                <Form
                    onFinish={handleSubmit}
                    layout="vertical"
                    id="myForm"
                    requiredMark={false}
                >
                    <Form.Item
                        name="contrasenia"
                        label="Contraseña anterior"
                        rules={[{ required: true, message: 'Ingresa su contraseña anterior' }]}
                    >
                        <Input.Password
                            placeholder="Contraseña anterior"
                            iconRender={(isVisible) => (isVisible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            onChange={(e) => handleChange(e, 'contrasenia')}
                        />
                    </Form.Item>
                    <Form.Item
                        name="nuevacontra"
                        label="Contraseña nueva"
                        rules={[{ required: true, message: 'Ingrese contraseña' },
                            {
                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                message: <>
                                    <div>La contraseña debe contener mínimo:</div>
                                    <div>8 Caracteres</div>
                                    <div>1 letra mayúscula</div>
                                    <div>1 número</div>
                                    <div>1 símbolo</div>
                                </>,
                            }]}
                        hasFeedback
                    >
                        <Input.Password
                            placeholder="Contraseña nueva"
                            iconRender={(isVisible) => (isVisible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            onChange={(e) => handleChange(e, 'nuevacontra')}
                        />
                    </Form.Item>
                    <Form.Item
                        name="nuevacontra2"
                        label="Repetir contraseña"
                        dependencies={['nuevacontra']}
                        hasFeedback
                        rules={[{ required: true, message: 'Ingrese la confirmación de la contraseña' },
                            ({ getFieldValue }) => ({
                                // eslint-disable-next-line no-restricted-syntax
                                validator(_, value) {
                                    if (!value || getFieldValue('nuevacontra') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('La contraseña ingresada no coincide con la primera'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            placeholder="Repetir contraseña"
                            iconRender={(isVisible) => (isVisible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            onChange={(e) => handleChange(e, 'nuevacontra2')}
                        />
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};
export default ChangePassword;
